import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChecklistItem } from '../../../models/checklist-item.model';

@Component({
  selector: 'lib-filter-checklist',
  templateUrl: './filter-checklist.component.html',
  styleUrls: ['./filter-checklist.component.scss'],
  standalone: false,
})
export class FilterChecklistComponent implements OnInit {
  @Input() filters: ChecklistItem[] = [];
  @Input() useApply: boolean = false;
  @Output() resetFilterEmitter = new EventEmitter<void>();
  @Output() removeFilterEmitter = new EventEmitter<ChecklistItem>();
  @Output() applyFilterEmitter = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}

  resetFilter() {
    this.filters = [];
    this.resetFilterEmitter.emit();
  }

  removeFilter(filter: ChecklistItem) {
    this.removeFilterEmitter.emit(filter);
  }

  applyFilter() {
    this.applyFilterEmitter.emit(true);
  }
}